import React from "react";
import HomeCarousel from "../../component/Home/HomeCarosel/HomeCarousel";
import Solutions from "../../component/Home/Solutions/Solutions";
import ExpertiseArea from "../../component/Home/ExpertiseArea/ExpertiseArea";
import OurPartners from "../../component/Home/OurPartners/OurPartners";
import OurClients from "../../component/Home/OurClients/OurClients";
import ContactForm from "../../component/ContactUs/ContactUsForm/ContactForm";
import TestimonialSection from "../../component/Home/testimonials/TestimonialSection";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import HomeOverview from "../../component/Home/HomeOverview/HomeOverview";
import FloatingContactUs from "../../component/floting_contact/FloatingContactUs";


const HomePage = () => {
  return (
    <>
      <ToastContainer />
      <HomeCarousel />
      <FloatingContactUs />
      <HomeOverview/>
      <Solutions />
      <ExpertiseArea />
      <OurPartners />
      <OurClients />
      <TestimonialSection />
      <ContactForm />
    </>
  );
};

export default HomePage;
